import { Outlet } from 'react-router-dom';

export const Container = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="container mx-auto">
      <Outlet />
      {children}
    </div>
  );
};
